import React, { Suspense, useState, useRef } from 'react';
// @ts-ignore
import { AuthProvider, useAuth } from './context/AuthContext';
// @ts-ignore
import CardDesigner from './components/CardDesignerFinal.jsx';
// @ts-ignore
import MenuBar from './components/MenuBar.jsx';
// @ts-ignore
import DatabaseManager from '../components/DatabaseManager.jsx';
// Import utilities first
import './utils/fabricErrorFixer';
import './utils/networkGuard';
// Import designer styles AFTER to override Tailwind
import './styles/index.css';
import './styles/DesignerApp.css'; // Designer-specific App styles
import './styles/designer-all.css'; // All component styles

const DesignerContent: React.FC = () => {
    // @ts-ignore
    const { user: authUser, logout, loading } = useAuth();
    const [adminOpen, setAdminOpen] = useState(false);
    // const [databaseOpen, setDatabaseOpen] = useState(false); // ELIMINADO
    const cardDesignerRef = useRef<any>(null);
    const isMobile = window.innerWidth <= 768;

    // Mock user for development/preview if auth fails
    const user = authUser || {
        _id: 'dev-user',
        name: 'Developer',
        email: 'dev@example.com',
        role: 'admin',
        company: 'Dev Mode'
    };

    // Mock handlers for MenuBar
    const handleNewDocument = () => console.log('🆕 Nuevo documento solicitado desde MenuBar');
    const handleOpenTemplate = () => {
        console.log('📋 Plantillas solicitadas desde MenuBar');
        if (cardDesignerRef.current && cardDesignerRef.current.openDesignBrowser) {
            cardDesignerRef.current.openDesignBrowser();
        }
    };
    const handleSaveDesign = () => {
        console.log('💾 Guardar solicitado desde MenuBar');
        if (cardDesignerRef.current && cardDesignerRef.current.saveDesign) {
            cardDesignerRef.current.saveDesign();
        }
    };
    const handleExport = () => console.log('📤 Exportar solicitado desde MenuBar');
    const handleUndo = () => console.log('↶ Deshacer solicitado desde MenuBar');
    const handleRedo = () => console.log('↷ Rehacer solicitado desde MenuBar');
    const handleFixObjectsOutOfBounds = () => console.log('🛠️ Corregir objetos solicitado desde MenuBar');
    const handleDatabaseOpen = () => {
        console.log('🗄️ Abriendo Database Manager');
        if (cardDesignerRef.current) {
            cardDesignerRef.current.openDatabaseManager();
        }
    };

    if (loading) {
        return <div className="flex items-center justify-center h-screen">Loading Designer...</div>;
    }

    return (
        <div className="App">
            <MenuBar
                user={user}
                onNewDocument={handleNewDocument}
                onOpenTemplate={handleOpenTemplate}
                onSave={handleSaveDesign}
                onSaveAs={() => { }}
                onExport={handleExport}
                onUndo={handleUndo}
                onRedo={handleRedo}
                canUndo={false}
                canRedo={false}
                onAdmin={() => setAdminOpen(true)}
                onLogout={logout}
                onFixObjects={handleFixObjectsOutOfBounds}
                hasObjectsOutOfBounds={false}
                onDatabaseOpen={handleDatabaseOpen}
            />

            <div className="app-main-content">
                {/* @ts-ignore */}
                <CardDesigner
                    ref={cardDesignerRef}
                    user={user}
                />
            </div>
        </div>
    );
};

const DesignerWrapper: React.FC = () => {
    return (
        <AuthProvider>
            <Suspense fallback={<div>Loading Designer...</div>}>
                <DesignerContent />
            </Suspense>
        </AuthProvider>
    );
};

export default DesignerWrapper;
